angular.module('study.dashboard').component('queriesDistributionReport', {
    templateUrl: 'modules/dashboard/components/queries-distribution-report/template.html',
    controller: [
        'ShareCrfSDK',
        '$q',
        'ShareCrfApiErrorCodes',
        'CrfService',
        'gettextCatalog',
        'CrdConfigurationService',
        'SitesService',
        function(
            ShareCrfSDK,
            $q,
            ShareCrfApiErrorCodes,
            CrfService,
            gettextCatalog,
            CrdConfigurationService,
            SitesService
        ) {
            var vm = this;

            vm.data = {};
            vm.loading = false;
            vm.error = null;

            Object.defineProperty(vm, 'ready', {
                get: function() {
                    return !vm.loading && !vm.error;
                },
            });

            vm.filters = {
                site: null,
            };

            vm.sitesData = [
                { id: null, code: null, name: gettextCatalog.getString('Todos') },
            ];

            vm.entityLabelPlural = CrdConfigurationService.getLabelPlural();
            vm.entityLabelSingular = CrdConfigurationService.getLabelSingular();

            vm.$onInit = function() {
                loadData();
            };

            function loadData() {
                vm.loading = true;

                return $q.resolve()
                    .then(function() {
                        return $q.all([
                            SitesService.list(),
                            ShareCrfSDK.dashboard.queriesDistributionDetail(),
                        ]);
                    })
                    .then(function(result) {
                        angular.forEach(result[0], function(site) {
                            vm.sitesData.push(site);
                        });

                        vm.data = result[1];
                    })
                    .catch(function(error) {
                        vm.error = ShareCrfApiErrorCodes.getHumanReadableMessage(error);

                        throw error;
                    })
                    .finally(function() {
                        vm.loading = false;
                    });
            }

            vm.percentage = function(value, totalKey) {
                var totalValue = vm.data[totalKey].total;

                return totalValue > 0 ? value * 100 / totalValue : 0;
            };

            vm.elementName = function(elementId) {
                var element = CrfService.getElement(elementId);

                return element
                    ? element.getFullLabel().join(' > ') :
                    gettextCatalog.getString('Elemento no disponible');
            };

            vm.reload = function() {
                var promise = ShareCrfSDK.dashboard.queriesDistributionDetail({
                    site: vm.filters.site,
                }).then(function(data) {
                    vm.data = data;
                });

                return loadRequest(promise);
            };

            function loadRequest(promise) {
                vm.loading = true;

                return $q.resolve()
                    .then(promise)
                    .catch(function(error) {
                        vm.error = ShareCrfApiErrorCodes.getHumanReadableMessage(error);

                        throw error;
                    })
                    .finally(function() {
                        vm.loading = false;
                    });
            }
        },
    ],
});
